export const muiFormControlOverrides = {
	styleOverrides: {
		root: ({ theme }) => {
			return {
				width: '100%',
				padding: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? 0 : `0 ${theme.tsGoUnit.tsUnitHalf}`,
			};
		},
	},
};
